import React, { useState, useEffect } from "react";
import { Container, Row, Col, Form, Button } from "react-bootstrap";
import { ArrowLeft, CheckCircle } from "react-bootstrap-icons";
import { Person, Envelope, Telephone } from "react-bootstrap-icons";
import logo from "../img/logo.png";
import background from "../img/logibback.jpg";
import { LuSend } from "react-icons/lu";
import { IoIosArrowUp } from "react-icons/io";
import { Filter, Loginuser, verify, FirmAndUser } from "../Redux/Slice/login/loginSlice";
import { LoginWithFingerprint } from "../Redux/Slice/WebAuthn/WebAuthnSlice";
import { toast, ToastContainer } from "react-toastify";
import { FaArrowLeft, FaArrowRight, FaFingerprint } from "react-icons/fa6";

import { useDispatch, useSelector } from "react-redux";
import Cookies from "js-cookie";
import { PacmanLoader, RingLoader, SyncLoader } from "react-spinners";

const Loginpage = () => {
    const dispatch = useDispatch();

    const { data, loginLoading, verifyData, filterData, loginError } = useSelector((state) => state.ClientLogin);
    const { loginLoading: fpLoginLoading, loginData: fpLoginData, error: fpError } = useSelector((state) => state.WebAuthn);

    const [fpBtnError, setFpBtnError] = useState(""); // inline error below fingerprint button


    const [username, setUsername] = useState("");
    const [selectedDatabase, setSelectedDatabase] = useState("");


    useEffect(() => {
        if (verifyData?.status === "OTP Match") {
            dispatch(Filter(verifyData?.token))
        }
    }, [verifyData]);

    // Fingerprint login: when fpLoginData arrives, dispatch Filter to get firm/year data
    useEffect(() => {
        if (fpLoginData?.status === "OTP Match") {
            dispatch(Filter(fpLoginData.token));
        }
    }, [fpLoginData]);

    // When filter data is ready from fingerprint login, set auth cookies and go to Firm/Year selection
    useEffect(() => {
        if (fpLoginData?.status === "OTP Match" && filterData) {
            const { token, SqlId, SqlName, Role, OwnerName } = fpLoginData;
            Cookies.set("authToken", token, { expires: 7 });
            if (SqlId) Cookies.set("SqlId", SqlId, { expires: 7 });
            if (SqlName) Cookies.set("SqlName", SqlName, { expires: 7 });
            if (Role) Cookies.set("Role", Role, { expires: 7 });
            if (OwnerName) Cookies.set("OwnerName", OwnerName, { expires: 7 });
            setPage("Firm");  // Go to firm/year selection page
        }
    }, [fpLoginData, filterData]);


    const Allset = () => {
        const activeLoginData = fpLoginData?.status === "OTP Match" ? fpLoginData : verifyData;
        const isMillStageUser = activeLoginData?.Role === "millstageuser";

        if (!selectedFirmId || !selectedYearId || (isMillStageUser && !selectedMasterId)) {
            toast.error(isMillStageUser ? "Please select Financial Year, Firm and Master" : "Please select Financial Year and Firm", {
                position: "bottom-right",
                hideProgressBar: true,
                style: {
                    background: "white",
                    color: "black",
                    borderRadius: "14px",
                    padding: "16px 20px",
                    fontSize: "14px",
                    fontWeight: "500",
                    boxShadow: "0 10px 25px rgba(0,0,0,0.15)",
                    minWidth: "280px"
                }
            });
        } else {
            // Support both OTP login and fingerprint login tokens
            const activeLoginData = fpLoginData?.status === "OTP Match" ? fpLoginData : verifyData;
            Cookies.set("authToken", activeLoginData.token, { expires: 7 });
            Cookies.set("Firm", selectedFirmId, { expires: 7 });
            Cookies.set("FinancialYear", selectedYearId, { expires: 7 });
            Cookies.set("Database", selectedDatabase, { expires: 7 });
            Cookies.set("YearDatabase", Yeardatabase, { expires: 7 });
            Cookies.set("MSdatabase", MSdatabase, { expires: 7 });

            if (isMillStageUser && selectedMasterId) {
                Cookies.set("millmaster", selectedMasterId, { expires: 7 });
            }

            if (activeLoginData.SqlId) {
                Cookies.set("SqlId", activeLoginData.SqlId, { expires: 7 });
            }
            if (activeLoginData.SqlName) {
                Cookies.set("SqlName", activeLoginData.SqlName, { expires: 7 });
            }
            if (activeLoginData.Role) {
                Cookies.set("Role", activeLoginData.Role, { expires: 7 });
            }
            if (activeLoginData.OwnerName) {
                Cookies.set("OwnerName", activeLoginData.OwnerName, { expires: 7 });
            }
            if (activeLoginData.AllowedPages) {
                localStorage.setItem("AllowedPages", JSON.stringify(activeLoginData.AllowedPages));
            } else {
                localStorage.removeItem("AllowedPages");
            }
            const greyProj = filterData?.Project_List?.find(p => p.DashboardProjectName === "GREY");
            if (greyProj) {
                localStorage.setItem("projectId", greyProj.DashboardProjectID);
            }
            window.location.reload();
        }

    };

    const [page, setPage] = useState("login");
    const [activeInput, setActiveInput] = useState(null);
    const [hoverRegister, setHoverRegister] = useState(false);
    const [hoverSendOtp, setHoverSendOtp] = useState(false);

    const [otp, setOtp] = useState(new Array(6).fill(""));
    const inputRefs = React.useRef([]);

    const [otpTimer, setOtpTimer] = useState(0);
    const [isOtpExpired, setIsOtpExpired] = useState(false);

    const [ReSendTimer, setReSendTimer] = useState(0);
    const [isReSendExpired, setIsReSendExpired] = useState(false);

    console.log(isOtpExpired);


    useEffect(() => {
        if (otpTimer <= 0 && ReSendTimer <= 0) return;

        const interval = setInterval(() => {

            setOtpTimer((prev) => {
                if (prev <= 1) {
                    setIsOtpExpired(true);
                    return 0;
                }
                return prev - 1;
            });

            setReSendTimer((prev) => {
                if (prev <= 1) {
                    setIsReSendExpired(true);
                    return 0;
                }
                return prev - 1;
            });

        }, 1000);

        return () => clearInterval(interval);
    }, [otpTimer, ReSendTimer]);

    const [yearIndex, setYearIndex] = useState(0);
    const yearItemRefs = React.useRef([]);

    const firmItemRefs = React.useRef([]);
    const [firmIndex, setFirmIndex] = useState(0);

    const [openYear, setOpenYear] = useState(false);
    const [selectedYear, setSelectedYear] = useState();
    const [selectedYearId, setSelectedYearId] = useState();
    const [Yeardatabase, setYeardatabase] = useState();
    const [MSdatabase, setMSdatabase] = useState();

    console.log(selectedYear);
    console.log(selectedYearId);
    console.log(Yeardatabase);
    console.log(MSdatabase);



    const [openFirm, setOpenFirm] = useState(false);
    const [selectedFirm, setSelectedFirm] = useState();
    const [selectedFirmId, setSelectedFirmId] = useState(null);

    const years = filterData?.AC_Year_List;
    const firms = filterData?.Firm_List;
    const masters = filterData?.ProcessGrp;

    console.log(years);


    const [openMaster, setOpenMaster] = useState(false);
    const [selectedMaster, setSelectedMaster] = useState();
    const [selectedMasterId, setSelectedMasterId] = useState(null);
    const [masterIndex, setMasterIndex] = useState(0);
    const masterItemRefs = React.useRef([]);
    const masterRef = React.useRef(null);

    const loginUsernameRef = React.useRef(null);
    const otpFirstRef = React.useRef(null);
    const yearRef = React.useRef(null);
    const firmRef = React.useRef(null);
    const registerUsernameRef = React.useRef(null);
    const submitRef = React.useRef(null);
    const sendOtpRef = React.useRef(null);

    useEffect(() => {
        if (page === "login" && loginUsernameRef.current) {
            loginUsernameRef.current.focus();
        }

        if (page === "otp" && otpFirstRef.current) {
            otpFirstRef.current.focus();
        }

        if (page === "Firm" && yearRef.current) {
            yearRef.current.focus();
        }

        if (page === "register" && registerUsernameRef.current) {
            registerUsernameRef.current.focus();
        }
    }, [page]);

    const inputWrapperStyle = {
        borderRadius: "14px",
        backgroundColor: "#f1f5f9",
        height: "clamp(45px, 6vw, 55px)",
        border: "1px solid #dbeafe",
    };

    const inputStyle = {
        border: "none",
        background: "transparent",
        boxShadow: "none",
        // marginLeft: "10px",
    };

    const buttonStyle = {
        padding: "clamp(10px, 3vw, 14px)",
        borderRadius: "12px",
        background: "linear-gradient(90deg, #2563EB, #1D4ED8)",
        border: "none",
    };

    const getInputWrapperStyle = (name) => ({
        borderRadius: "14px",
        backgroundColor: "#f1f5f9",
        height: "clamp(45px, 6vw, 55px)",
        border:
            activeInput === name
                ? "2px solid #2563EB"
                : "2px solid #dbeafe",
        boxShadow:
            activeInput === name
                ? "0 0 0 3px rgba(37,99,235,0.25)"
                : "none",
        transition: "all 0.2s ease",
    });

    const handleChange = (element, index) => {
        if (!/^\d*$/.test(element.value)) return;

        const newOtp = [...otp];
        newOtp[index] = element.value;
        setOtp(newOtp);

        // Next input pe focus
        if (element.value && index < 5) {
            inputRefs.current[index + 1].focus();
        }
    };

    const handleKeyDown = (e, index) => {
        if (e.key === "Backspace" && !otp[index] && index > 0) {
            inputRefs.current[index - 1].focus();
        }
    };

    const handlePaste = (e) => {
        e.preventDefault();
        const pasteData = e.clipboardData.getData("text").slice(0, 6);

        if (!/^\d+$/.test(pasteData)) return;

        const newOtp = pasteData.split("");
        setOtp(newOtp);

        newOtp.forEach((digit, i) => {
            if (inputRefs.current[i]) {
                inputRefs.current[i].value = digit;
            }
        });

        if (inputRefs.current[5]) {
            inputRefs.current[5].focus();
        }
    };

    return (
        <>

            <style>
                {`
                              @keyframes rotation {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}

@keyframes animloader42 {
  0% {
    box-shadow: 20px 0 #ffffff, 40px 0 rgba(255,255,255,0.2);
  }
  50% {
    box-shadow: 20px 0 rgba(255,255,255,0.2), 40px 0 #ffffff;
  }
  100% {
    box-shadow: 20px 0 #ffffff, 40px 0 #ffffff;
  }
}

@media (max-width: 576px) {
  .login-card {
    padding: 20px 15px !important;
    border-radius: 20px !important;
  }
  .login-logo {
    width: 170px !important;
    padding: 8px !important;
    margin-bottom: 8px !important;
  }
  .login-title {
    font-size: 20px !important;
    margin-bottom: 4px !important;
  }
  .login-subtitle {
    font-size: 12px !important;
    margin-bottom: 12px !important;
  }
  #fingerprint-login-btn {
    padding: 10px !important;
    font-size: 13px !important;
  }
}
                                                                          `}
            </style>
            <div
                className="d-flex justify-content-center align-items-center position-relative min-vh-100"
                style={{
                    backgroundImage: `url(${background})`,
                    backgroundSize: "cover",
                    backgroundPosition: "center",
                    minHeight: "100vh",
                    padding: "20px 0",
                }}
            >
                {/* Blur Overlay */}
                <div
                    className="position-absolute"
                    style={{
                        inset: 0,
                        backdropFilter: "blur(12px)",
                        backgroundColor: "rgba(120,130,150,0.35)",
                    }}
                ></div>

                <Container className="position-relative">
                    <Row className="justify-content-center">
                        <Col xs={11} sm={9} md={7} lg={6} xl={4}>
                            <div
                                className="login-card shadow-lg"
                                style={{
                                    borderRadius: "25px",
                                    backgroundColor: "rgba(255,255,255,0.6)",
                                    backdropFilter: "blur(20px)",
                                    padding: "clamp(20px, 4vw, 30px)",
                                }}
                            >
                                {/* ================= LOGIN ================= */}
                                {page === "login" && (
                                    <>
                                        <div className="text-center mb-4">
                                            <img
                                                src={logo}
                                                alt="logo"
                                                className="img-fluid mb-3 p-3 login-logo"
                                                style={{
                                                    borderRadius: "15px",
                                                    background: "#ffffff",
                                                    boxShadow: "0 8px 20px rgba(0,0,0,0.1)",
                                                    width: "250px",
                                                }}
                                            />

                                            <h2 className="fw-bold mb-2 login-title">Welcome Back</h2>
                                            <p className="login-subtitle" style={{ color: "#64748B", fontSize: "14px" }}>
                                                Secure ERP Access Portal
                                            </p>
                                        </div>

                                        <Form onSubmit={(e) => {
                                            e.preventDefault();

                                            sendOtpRef.current?.focus();
                                            sendOtpRef.current?.click();
                                        }}>
                                            <Form.Group className="mb-4 text-start">
                                                <Form.Label
                                                    className="fw-bold small"
                                                    style={{ color: "#405870" }}
                                                >
                                                    USER NAME
                                                </Form.Label>

                                                <div
                                                    className="d-flex align-items-center px-3"
                                                    style={getInputWrapperStyle("loginUsername")}
                                                    onClick={() => setActiveInput("loginUsername")}
                                                >
                                                    <Person
                                                        size={20}
                                                        color={
                                                            activeInput === "loginUsername"
                                                                ? "#2563EB"
                                                                : "#64748B"
                                                        }
                                                        className="me-2"
                                                    />

                                                    <Form.Control
                                                        type="text"
                                                        ref={loginUsernameRef}
                                                        placeholder="Enter your username"
                                                        style={inputStyle}
                                                        onFocus={() => setActiveInput("loginUsername")}
                                                        onBlur={() => setActiveInput(null)}
                                                        onChange={(e) => setUsername(e.target.value)}
                                                    // onKeyDown={(e) => {
                                                    //     if (e.key === "Enter") {
                                                    //         e.preventDefault();

                                                    //         sendOtpRef.current?.focus();
                                                    //         sendOtpRef.current?.click();
                                                    //     }
                                                    // }}
                                                    />
                                                </div>
                                            </Form.Group>

                                            <Button
                                                onClick={async () => {

                                                    if (!username) {
                                                        toast.error("Please enter username", {
                                                            position: "bottom-right",
                                                            hideProgressBar: true,
                                                        });
                                                        return;
                                                    }

                                                    try {
                                                        await dispatch(

                                                            Loginuser({ User_ID: username })
                                                        ).unwrap();

                                                        setOtpTimer(150);
                                                        setIsOtpExpired(false);

                                                        setReSendTimer(60)
                                                        setIsReSendExpired(false)

                                                        toast.success(`OTP sent to ${username}`, {
                                                            position: "bottom-right",
                                                            icon: "✔",
                                                            hideProgressBar: true,
                                                            style: {
                                                                background: "#e5e7eb",
                                                                color: "#111827",
                                                                borderRadius: "14px",
                                                                padding: "16px 20px",
                                                                fontSize: "14px",
                                                                fontWeight: "500",
                                                                boxShadow: "0 10px 25px rgba(0,0,0,0.15)",
                                                                minWidth: "280px"
                                                            }
                                                        });

                                                        setPage("otp");

                                                    } catch (error) {

                                                        toast.error("User not found", {
                                                            position: "bottom-right",
                                                            hideProgressBar: true,
                                                            style: {
                                                                background: "white",
                                                                color: "black",
                                                                // borderRadius: "14px",
                                                                padding: "16px 20px",
                                                                fontSize: "14px",
                                                                fontWeight: "500",
                                                                boxShadow: "0 10px 25px rgba(0,0,0,0.15)",
                                                                minWidth: "280px"
                                                            }
                                                        });
                                                    }
                                                }}
                                                ref={sendOtpRef}
                                                type="button"
                                                disabled={loginLoading}
                                                className="w-100 fw-semibold d-flex align-items-center justify-content-center"
                                                onMouseEnter={() => setHoverSendOtp(true)}
                                                onMouseLeave={() => setHoverSendOtp(false)}
                                                onFocus={() => setActiveInput("sendOtpBtn")}
                                                onBlur={() => setActiveInput(null)}
                                                style={{
                                                    ...buttonStyle,
                                                    transition: "all 0.25s ease",
                                                    boxShadow: activeInput === "sendOtpBtn"
                                                        ? ""
                                                        : hoverSendOtp
                                                            ? "0 8px 20px rgba(37,99,235,0.4)"
                                                            : "none",
                                                    transform: hoverSendOtp ? "translateY(-2px)" : "translateY(0px)",
                                                }}
                                            >

                                                <>
                                                    {loginLoading ? (
                                                        <RingLoader
                                                            color="#ffffff"
                                                            size={25}
                                                        />
                                                    ) : (
                                                        <>
                                                            Send OTP
                                                            <FaArrowRight className="ms-2" />
                                                        </>
                                                    )}
                                                </>

                                            </Button>
                                        </Form>

                                        {/* ── Fingerprint Login ── */}
                                        <div style={{ margin: "16px 0 0" }}>
                                            <div style={{ display: "flex", alignItems: "center", gap: "10px", margin: "0 0 12px" }}>
                                                <div style={{ flex: 1, height: "1px", background: "#cbd5e1" }} />
                                                <span style={{ fontSize: "12px", color: "#334155", fontWeight: "600", textTransform: "uppercase", letterSpacing: "0.5px", whiteSpace: "nowrap" }}>or</span>
                                                <div style={{ flex: 1, height: "1px", background: "#cbd5e1" }} />
                                            </div>
                                            <button
                                                id="fingerprint-login-btn"
                                                onClick={async () => {
                                                    setFpBtnError(""); // clear previous error
                                                    if (!username) {
                                                        setFpBtnError("Please enter your username first.");
                                                        return;
                                                    }
                                                    const result = await dispatch(LoginWithFingerprint(username));
                                                    if (result.meta.requestStatus === "rejected") {
                                                        setFpBtnError(result.payload || "Fingerprint authentication failed. Please try again.");
                                                    }
                                                }}
                                                disabled={fpLoginLoading}
                                                style={{
                                                    width: "100%",
                                                    padding: "13px",
                                                    background: fpLoginLoading
                                                        ? "#94a3b8"
                                                        : "linear-gradient(135deg, #4f46e5 0%, #7c3aed 100%)",
                                                    color: "#fff",
                                                    border: "none",
                                                    borderRadius: "12px",
                                                    fontSize: "14px",
                                                    fontWeight: 600,
                                                    cursor: fpLoginLoading ? "not-allowed" : "pointer",
                                                    display: "flex",
                                                    alignItems: "center",
                                                    justifyContent: "center",
                                                    gap: "10px",
                                                    boxShadow: fpLoginLoading ? "none" : "0 4px 15px rgba(79,70,229,0.35)",
                                                    transition: "all 0.2s ease",
                                                }}
                                            >
                                                <FaFingerprint size={20} />
                                                {fpLoginLoading ? "Verifying Fingerprint..." : "Login with Fingerprint"}
                                            </button>

                                            {/* Inline error below fingerprint button */}
                                            {fpBtnError && (
                                                <div
                                                    style={{
                                                        marginTop: "10px",
                                                        padding: "10px 14px",
                                                        background: "rgba(239,68,68,0.08)",
                                                        border: "1px solid rgba(239,68,68,0.35)",
                                                        borderRadius: "10px",
                                                        display: "flex",
                                                        alignItems: "center",
                                                        gap: "8px",
                                                    }}
                                                >
                                                    <span style={{ fontSize: "16px" }}>❌</span>
                                                    <span style={{ fontSize: "12px", color: "#dc2626", fontWeight: 500 }}>
                                                        {fpBtnError}
                                                    </span>
                                                </div>
                                            )}

                                            <p style={{ fontSize: "12px", color: "#334155", fontWeight: "500", textAlign: "center", marginTop: "8px", marginBottom: 0 }}>
                                                Enter username above, then scan your fingerprint
                                            </p>

                                            <div
                                                style={{
                                                    margin: "8px auto 16px",
                                                    width: "80%",
                                                    height: "1px",
                                                    backgroundColor: "#cbd5e1",
                                                }}
                                            ></div>
                                        </div>

                                        <div className="text-center">
                                            <p style={{ fontSize: "14px", color: "#475569" }}>
                                                New to the system?
                                            </p>
                                            <span
                                                onClick={() => setPage("register")}
                                                onMouseEnter={() => setHoverRegister(true)}
                                                onMouseLeave={() => setHoverRegister(false)}
                                                style={{
                                                    color: "#2563EB",
                                                    fontWeight: "600",
                                                    cursor: "pointer",
                                                    display: "inline-flex",
                                                    alignItems: "center",
                                                    transition: "transform 0.18s ease, text-shadow 0.18s ease",
                                                    transformOrigin: "left center",
                                                    transform: hoverRegister ? "translateY(-1px)" : "translateY(0px)",
                                                    textShadow: hoverRegister
                                                        ? "0 4px 8px rgba(37,99,235,0.25)"
                                                        : "none",
                                                }}
                                            >
                                                Connect with us
                                                <span
                                                    style={{
                                                        marginLeft: "6px",
                                                        transition: "transform 0.18s ease",
                                                        transform: hoverRegister
                                                            ? "translateX(6px)"
                                                            : "translateX(0px)",
                                                    }}
                                                >
                                                    <FaArrowRight />
                                                </span>
                                            </span>
                                        </div>
                                    </>
                                )}

                                {/* ================= OTP ================= */}
                                {page === "otp" && (
                                    <>
                                        <div className="text-center mb-4">
                                            <img
                                                src={logo}
                                                alt="logo"
                                                className="img-fluid mb-3 p-3 login-logo"
                                                style={{
                                                    borderRadius: "15px",
                                                    background: "#ffffff",
                                                    boxShadow: "0 8px 20px rgba(0,0,0,0.1)",
                                                    width: "250px",
                                                }}
                                            />

                                            <h3 className="fw-bold login-title">Enter Your OTP</h3>
                                            <p className="login-subtitle m-0" style={{ color: "#64748B", fontSize: "14px" }}>
                                                We've sent a 6-digit verification code
                                            </p>
                                        </div>

                                        <div className="text-center mb-3 ">
                                            {!isOtpExpired ? (
                                                <small style={{ color: "#64748b", fontWeight: "500" }}>
                                                    OTP expires in <span style={{ color: "#ef4444", fontWeight: "600" }}>{otpTimer}s</span>
                                                </small>
                                            ) : (
                                                <small style={{ color: "#ef4444", fontWeight: "500" }}>
                                                    OTP expired
                                                </small>
                                            )}
                                        </div>

                                        <div className="mb-4 d-flex justify-content-center">
                                            {otp.map((data, index) => (
                                                <input
                                                    key={index}
                                                    ref={(el) => {
                                                        inputRefs.current[index] = el;
                                                        if (index === 0) otpFirstRef.current = el;
                                                    }}
                                                    type="text"
                                                    maxLength="1"
                                                    value={data}

                                                    className="me-2"
                                                    style={{
                                                        width: "clamp(35px, 8vw, 45px)",
                                                        height: "clamp(45px, 8vw, 55px)",
                                                        textAlign: "center",
                                                        borderRadius: "10px",
                                                        border: "1px solid #cbd5e1",
                                                        backgroundColor: "#f1f5f9",
                                                        fontSize: "clamp(14px, 3vw, 18px)",
                                                        fontWeight: "bold",
                                                        outline: "none",
                                                        transition: "all 0.2s ease",
                                                    }}
                                                    onChange={(e) => handleChange(e.target, index)}
                                                    // onChange={(e) => setotpverify(e.target.value)}
                                                    onKeyDown={(e) => {
                                                        handleKeyDown(e, index);

                                                        if (e.key === "Enter") {
                                                            e.preventDefault();

                                                            if (index < otp.length - 1) {
                                                                inputRefs.current[index + 1]?.focus();
                                                            } else {
                                                                document.getElementById("confirmOtpBtn")?.click();
                                                            }
                                                        }
                                                    }}
                                                    onPaste={handlePaste}
                                                    onFocus={(e) => {
                                                        e.target.style.border = "2px solid #2563EB";
                                                        e.target.style.boxShadow = "0 0 0 3px rgba(37,99,235,0.25)";
                                                    }}

                                                    onBlur={(e) => {
                                                        e.target.style.border = "1px solid #cbd5e1";
                                                        e.target.style.boxShadow = "none";
                                                    }}
                                                />
                                            ))}
                                        </div>

                                        <Button
                                            id="confirmOtpBtn"
                                            type="button"
                                            className="w-100 fw-semibold d-flex align-items-center justify-content-center"
                                            onMouseEnter={() => setHoverSendOtp(true)}
                                            onMouseLeave={() => setHoverSendOtp(false)}


                                            onClick={async () => {

                                                if (isOtpExpired) {
                                                    toast.error("OTP expired. Please resend OTP", {
                                                        position: "bottom-right",
                                                        hideProgressBar: true,
                                                        style: {
                                                            background: "#e5e7eb",
                                                            color: "#111827",
                                                            borderRadius: "14px",
                                                            padding: "16px 20px",
                                                            fontSize: "14px",
                                                            fontWeight: "500",
                                                            boxShadow: "0 10px 25px rgba(0,0,0,0.15)",
                                                            minWidth: "280px"
                                                        }
                                                    });
                                                    return;
                                                }

                                                try {

                                                    const response = await dispatch(
                                                        verify({
                                                            OTP: otp.join(""),
                                                            User_ID: username,
                                                        })
                                                    ).unwrap();

                                                    if (response?.status === "OTP Match") {

                                                        toast.success(response.status, {
                                                            position: "bottom-right",
                                                            icon: "✔",
                                                            hideProgressBar: true,
                                                            style: {
                                                                background: "#e5e7eb",
                                                                color: "#111827",
                                                                borderRadius: "14px",
                                                                padding: "16px 20px",
                                                                fontSize: "14px",
                                                                fontWeight: "500",
                                                                boxShadow: "0 10px 25px rgba(0,0,0,0.15)",
                                                                minWidth: "280px"
                                                            }
                                                        });

                                                        setPage("Firm");

                                                    } else {

                                                        toast.error(response?.status || "OTP Not Match", {
                                                            position: "bottom-right",
                                                            hideProgressBar: true,
                                                            style: {
                                                                background: "#e5e7eb",
                                                                color: "#111827",
                                                                borderRadius: "14px",
                                                                padding: "16px 20px",
                                                                fontSize: "14px",
                                                                fontWeight: "500",
                                                                boxShadow: "0 10px 25px rgba(0,0,0,0.15)",
                                                                minWidth: "280px"
                                                            }
                                                        });

                                                    }

                                                } catch (error) {
                                                    toast.error(
                                                        error?.message || "Server Error",
                                                        {
                                                            position: "bottom-right",
                                                            hideProgressBar: true,
                                                            style: {
                                                                background: "#e5e7eb",
                                                                color: "#111827",
                                                                borderRadius: "14px",
                                                                padding: "16px 20px",
                                                                fontSize: "14px",
                                                                fontWeight: "500",
                                                                boxShadow: "0 10px 25px rgba(0,0,0,0.15)",
                                                                minWidth: "280px"
                                                            }
                                                        }
                                                    );
                                                }

                                            }}
                                            onFocus={() => setActiveInput("confirmotp")}
                                            onBlur={() => setActiveInput(null)}
                                            // onClick={() => setPage("Firm")}
                                            style={{
                                                ...buttonStyle,
                                                transition: "all 0.25s ease",

                                                boxShadow:
                                                    activeInput === "confirmotp"
                                                        ? " "
                                                        : hoverSendOtp
                                                            ? "0 8px 20px rgba(37,99,235,0.4)"
                                                            : "none",

                                                transform: hoverSendOtp ? "translateY(-2px)" : "translateY(0px)",
                                                outline: "none",
                                            }}
                                        >
                                            Confirm OTP
                                            <CheckCircle size={18} className="ms-2" />
                                        </Button>



                                        <div className="text-center mt-3">
                                            <small style={{ color: "#64748B" }}>
                                                Didn't receive code?{" "}
                                                <span
                                                    disabled={loginLoading}
                                                    onClick={async () => {

                                                        setOtp(new Array(6).fill(""));

                                                        setTimeout(() => {
                                                            inputRefs.current[0]?.focus();
                                                        }, 0);

                                                        if (!isReSendExpired) {
                                                            toast.error(`Please wait ${ReSendTimer}s before resending OTP`, {
                                                                position: "bottom-right",
                                                                hideProgressBar: true,
                                                                style: {
                                                                    background: "white",
                                                                    color: "black",
                                                                    borderRadius: "14px",
                                                                    padding: "16px 20px",
                                                                    fontSize: "14px",
                                                                    fontWeight: "500",
                                                                    boxShadow: "0 10px 25px rgba(0,0,0,0.15)",
                                                                    minWidth: "280px"
                                                                }
                                                            });
                                                            return;
                                                        }


                                                        try {
                                                            await dispatch(
                                                                Loginuser({ User_ID: username })
                                                            ).unwrap();

                                                            setOtpTimer(150);
                                                            setIsOtpExpired(false);

                                                            setReSendTimer(60)
                                                            setIsReSendExpired(false)

                                                            toast.success(`OTP sent to ${username}`, {
                                                                position: "bottom-right",
                                                                icon: "✔",
                                                                hideProgressBar: true,
                                                                style: {
                                                                    background: "#e5e7eb",
                                                                    color: "#111827",
                                                                    borderRadius: "14px",
                                                                    padding: "16px 20px",
                                                                    fontSize: "14px",
                                                                    fontWeight: "500",
                                                                    boxShadow: "0 10px 25px rgba(0,0,0,0.15)",
                                                                    minWidth: "280px"
                                                                }
                                                            });

                                                        } catch (error) {

                                                            toast.error("User not found", {
                                                                position: "bottom-right",
                                                                hideProgressBar: true,
                                                                style: {
                                                                    background: "white",
                                                                    color: "black",
                                                                    borderRadius: "14px",
                                                                    padding: "16px 20px",
                                                                    fontSize: "14px",
                                                                    fontWeight: "500",
                                                                    boxShadow: "0 10px 25px rgba(0,0,0,0.15)",
                                                                    minWidth: "280px"
                                                                }
                                                            });
                                                        }
                                                    }}
                                                    style={{
                                                        color: "#2563EB",
                                                        cursor: "pointer",
                                                        fontWeight: "600",

                                                        alignItems: "center",
                                                    }}
                                                >


                                                    {loginLoading ? (
                                                        <SyncLoader color="#fffefe" size={10} />
                                                    ) : (
                                                        <>
                                                            {!isReSendExpired
                                                                ? `Resend in ${ReSendTimer}s`
                                                                : "Resend Again"
                                                            }
                                                        </>
                                                    )}
                                                </span>
                                            </small>
                                        </div>

                                        <div
                                            onClick={() => {
                                                if (loginLoading) {
                                                    setPage("otp");
                                                } else {
                                                    setPage("login");
                                                }
                                            }}

                                            onMouseEnter={() => setHoverRegister(true)}
                                            onMouseLeave={() => setHoverRegister(false)}
                                            style={{
                                                cursor: "pointer",
                                                color: "#475569",
                                                display: "inline-flex",
                                                alignItems: "center",
                                                justifyContent: "center",
                                                transition: "transform 0.18s ease, text-shadow 0.18s ease",
                                                transformOrigin: "right center",
                                                transform: hoverRegister ? "translateY(-1px)" : "translateY(0px)",
                                            }}
                                            className="text-center mt-4"
                                        >
                                            <span
                                                style={{
                                                    marginRight: "6px",
                                                    transition: "transform 0.18s ease",
                                                    transform: hoverRegister
                                                        ? "translateX(-6px)"
                                                        : "translateX(0px)",
                                                }}
                                            >
                                                <FaArrowLeft />
                                            </span>
                                            Back to Login
                                        </div>
                                    </>
                                )}

                                {/* =================Firm=============== */}

                                {page === "Firm" && (
                                    <div>
                                        <div className="text-center mb-4">
                                            <img
                                                src={logo}
                                                alt="logo"
                                                className="img-fluid mb-3 p-3 login-logo"
                                                style={{
                                                    borderRadius: "15px",
                                                    background: "#ffffff",
                                                    boxShadow: "0 8px 20px rgba(0,0,0,0.1)",
                                                    width: "250px",
                                                }}
                                            />
                                        </div>

                                        {/* Title */}
                                        <h2
                                            className="text-center fw-bold mb-2 login-title"
                                            style={{ color: "#1f2937" }}
                                        >
                                            Select Financial Year And Firm
                                        </h2>
                                        <p
                                            className="text-center mb-4 login-subtitle"
                                            style={{ color: "#64748b" }}
                                        >
                                            Secure ERP Access Portal
                                        </p>

                                        {/* Form */}
                                        <Form>
                                            <Form.Group className="mb-4 text-start position-relative">
                                                <Form.Label
                                                    className="fw-bold small"
                                                    style={{ color: "#475569" }}
                                                >
                                                    FINANCIAL YEAR
                                                </Form.Label>

                                                {/* Selected Box */}
                                                <div
                                                    ref={yearRef}
                                                    tabIndex={0}
                                                    onClick={() => {
                                                        setActiveInput("yearSelect");
                                                        setOpenYear(!openYear);
                                                        setOpenFirm(false);


                                                    }}



                                                    onFocus={() => setActiveInput("yearSelect")}
                                                    onBlur={() => setActiveInput(null)}

                                                    onKeyDown={(e) => {
                                                        if (e.key === "Enter") {
                                                            e.preventDefault();
                                                            setOpenYear(true);

                                                            setTimeout(() => {
                                                                yearItemRefs.current[0]?.focus();
                                                                setYearIndex(0);
                                                            }, 0);
                                                        }

                                                        if (e.key === "ArrowDown") {
                                                            e.preventDefault();
                                                            setOpenYear(true);

                                                            setTimeout(() => {
                                                                yearItemRefs.current[0]?.focus();
                                                                setYearIndex(0);
                                                            }, 0);
                                                        }
                                                    }}
                                                    style={{
                                                        padding: "14px 18px",
                                                        borderRadius: "16px",
                                                        border: "2px solid #2563EB",
                                                        backgroundColor: "#fff",
                                                        display: "flex",
                                                        justifyContent: "space-between",
                                                        alignItems: "center",
                                                        cursor: "pointer",
                                                        transition: "all 0.2s ease",
                                                    }}
                                                >
                                                    <span style={{ color: selectedYear ? "inherit" : "#94a3b8" }}>
                                                        {selectedYear || "Select Financial Year"}
                                                    </span>
                                                    <span
                                                        style={{
                                                            color: "#2563EB",
                                                            display: "flex",
                                                            alignItems: "center",
                                                        }}
                                                    >
                                                        <IoIosArrowUp size={20} style={{
                                                            transition: "transform 0.3s ease",
                                                            transform: openYear ? "rotate(180deg)" : "rotate(0deg)",
                                                        }} />
                                                    </span>
                                                </div>

                                                {/* Dropdown Box */}
                                                {openYear && (
                                                    <div
                                                        style={{
                                                            position: "absolute",
                                                            top: "100%",
                                                            left: 0,
                                                            width: "100%",
                                                            marginTop: "10px",
                                                            borderRadius: "16px",
                                                            border: "2px solid #2563EB",
                                                            backgroundColor: "#f1f5f9",
                                                            overflow: "hidden",
                                                            zIndex: 1000,
                                                            boxShadow: "0 10px 25px rgba(0,0,0,0.15)",
                                                        }}
                                                    >
                                                        <div
                                                            style={{
                                                                padding: "12px 16px",
                                                                backgroundColor: "#cbd5e1",
                                                                fontWeight: "600",
                                                                fontSize: "14px",
                                                            }}
                                                        >
                                                            Select Financial Year
                                                        </div>

                                                        {years?.map((year, index) => (
                                                            <div
                                                                key={year.AcYearID}
                                                                ref={(el) => (yearItemRefs.current[index] = el)}
                                                                tabIndex={0}
                                                                onClick={() => {
                                                                    setSelectedYear(year.AcYear);
                                                                    setSelectedYearId(year.AcYearID);
                                                                    setYeardatabase(year.DBName);
                                                                    setMSdatabase(year.MSDBName);
                                                                    setOpenYear(false);

                                                                    const activeLoginData =
                                                                        fpLoginData?.status === "OTP Match"
                                                                            ? fpLoginData
                                                                            : verifyData;

                                                                    if (activeLoginData?.Role === "millstageuser") {
                                                                        dispatch(
                                                                            FirmAndUser({
                                                                                MSDBName: year.MSDBName, // Fixed
                                                                                token: activeLoginData.token
                                                                            })
                                                                        );
                                                                    }

                                                                    setTimeout(() => {
                                                                        setOpenFirm(true);
                                                                        setFirmIndex(0);

                                                                        setTimeout(() => {
                                                                            firmItemRefs.current[0]?.focus();
                                                                        }, 0);
                                                                    }, 0);
                                                                }}
                                                                onKeyDown={(e) => {
                                                                    if (e.key === "ArrowDown") {
                                                                        e.preventDefault();
                                                                        const next =
                                                                            index + 1 < years.length ? index + 1 : 0;
                                                                        setYearIndex(next);
                                                                        yearItemRefs.current[next]?.focus();
                                                                    }

                                                                    if (e.key === "ArrowUp") {
                                                                        e.preventDefault();
                                                                        const prev =
                                                                            index - 1 >= 0
                                                                                ? index - 1
                                                                                : years.length - 1;
                                                                        setYearIndex(prev);
                                                                        yearItemRefs.current[prev]?.focus();
                                                                    }

                                                                    if (e.key === "Enter") {
                                                                        e.preventDefault();

                                                                        setSelectedYear(year.AcYear);
                                                                        setSelectedYearId(year.AcYearID);
                                                                        setYeardatabase(year.DBName);
                                                                        setMSdatabase(year.MSDBName);
                                                                        setOpenYear(false);

                                                                        const activeLoginData =
                                                                            fpLoginData?.status === "OTP Match"
                                                                                ? fpLoginData
                                                                                : verifyData;

                                                                        if (activeLoginData?.Role === "millstageuser") {
                                                                            dispatch(
                                                                                FirmAndUser({
                                                                                    MSDBName: year.MSDBName, // Fixed
                                                                                    token: activeLoginData.token
                                                                                })
                                                                            );
                                                                        }

                                                                        setTimeout(() => {
                                                                            setOpenFirm(true);
                                                                            setFirmIndex(0);

                                                                            setTimeout(() => {
                                                                                firmItemRefs.current[0]?.focus();
                                                                            }, 0);
                                                                        }, 0);
                                                                    }
                                                                    if (e.key === "Escape") {
                                                                        setOpenYear(false);
                                                                        yearRef.current?.focus();
                                                                    }
                                                                }}
                                                                onMouseEnter={(e) => {
                                                                    e.currentTarget.style.backgroundColor = "#e0ecff";
                                                                }}
                                                                onMouseLeave={(e) => {
                                                                    e.currentTarget.style.backgroundColor =
                                                                        selectedYear === year ? "#dbeafe" : "transparent";
                                                                }}
                                                                onFocus={(e) => {
                                                                    e.currentTarget.style.backgroundColor = "#dbeafe";
                                                                    e.currentTarget.style.outline = "none";
                                                                }}
                                                                onBlur={(e) => {
                                                                    e.currentTarget.style.backgroundColor =
                                                                        selectedYear === year ? "#dbeafe" : "transparent";
                                                                }}

                                                                style={{
                                                                    padding: "14px 16px",
                                                                    cursor: "pointer",
                                                                    backgroundColor:
                                                                        selectedYear === year ? "#dbeafe" : "transparent",
                                                                    color:
                                                                        selectedYear === year ? "#1d4ed8" : "#374151",
                                                                    fontWeight:
                                                                        selectedYear === year ? "600" : "500",
                                                                    transition: "all 0.2s ease",
                                                                    display: "flex",
                                                                    justifyContent: "space-between",
                                                                    alignItems: "center",
                                                                    borderLeft:
                                                                        selectedYear === year
                                                                            ? "4px solid #2563EB"
                                                                            : "4px solid transparent",
                                                                }}

                                                            >
                                                                {year.AcYear}

                                                                {selectedYear === year && (
                                                                    <span style={{ color: "#2563EB" }}>✓</span>
                                                                )}
                                                            </div>
                                                        ))}
                                                    </div>
                                                )}
                                            </Form.Group>

                                            <Form.Group className="mb-4 text-start position-relative">
                                                <Form.Label
                                                    className="fw-bold small"
                                                    style={{ color: "#475569" }}
                                                >
                                                    FIRM
                                                </Form.Label>

                                                <div
                                                    ref={firmRef}
                                                    tabIndex={0}
                                                    onClick={() => {
                                                        setActiveInput("firmSelect");
                                                        setOpenFirm(!openFirm);
                                                        setOpenYear(false);
                                                    }}
                                                    onFocus={() => setActiveInput("firmSelect")}
                                                    onBlur={() => setActiveInput(null)}

                                                    onKeyDown={(e) => {
                                                        if (e.key === "Enter" || e.key === "ArrowDown") {
                                                            e.preventDefault();
                                                            setOpenFirm(true);
                                                            setOpenYear(false);

                                                            setTimeout(() => {
                                                                setFirmIndex(0);
                                                                firmItemRefs.current[0]?.focus();
                                                            }, 0);
                                                        }
                                                    }}
                                                    style={{
                                                        padding: "14px 18px",
                                                        borderRadius: "16px",
                                                        border: "2px solid #2563EB",
                                                        backgroundColor: "#fff",
                                                        display: "flex",
                                                        justifyContent: "space-between",
                                                        alignItems: "center",
                                                        cursor: "pointer",
                                                    }}
                                                >
                                                    <span style={{ color: selectedFirm ? "inherit" : "#94a3b8" }}>
                                                        {selectedFirm || "Select Firm"}
                                                    </span>
                                                    <span
                                                        style={{
                                                            color: "#2563EB",
                                                            display: "flex",
                                                            alignItems: "center",
                                                        }}
                                                    >
                                                        <IoIosArrowUp size={20} style={{
                                                            transition: "transform 0.3s ease",
                                                            transform: openFirm ? "rotate(180deg)" : "rotate(0deg)",
                                                        }} />
                                                    </span>
                                                </div>

                                                {openFirm && (
                                                    <div
                                                        style={{
                                                            position: "absolute",
                                                            top: "100%",
                                                            left: 0,
                                                            width: "100%",
                                                            marginTop: "10px",
                                                            borderRadius: "16px",
                                                            border: "2px solid #2563EB",
                                                            backgroundColor: "#f1f5f9",
                                                            overflow: "hidden",
                                                            zIndex: 1000,
                                                            boxShadow: "0 10px 25px rgba(0,0,0,0.15)",
                                                        }}
                                                    >
                                                        <div
                                                            style={{
                                                                padding: "12px 16px",
                                                                backgroundColor: "#cbd5e1",
                                                                fontWeight: "600",
                                                                fontSize: "14px",
                                                            }}
                                                        >
                                                            Select Firm
                                                        </div>

                                                        {firms?.map((firm, index) => (
                                                            <div
                                                                key={firm.DashboardFirmID}
                                                                ref={(el) => (firmItemRefs.current[index] = el)}
                                                                tabIndex={0}

                                                                onClick={() => {
                                                                    setSelectedFirm(firm.GroupName);
                                                                    setSelectedFirmId(firm.DashboardFirmID);
                                                                    setSelectedDatabase(firm.databasename);
                                                                    setOpenFirm(false);
                                                                }}

                                                                onKeyDown={(e) => {
                                                                    if (e.key === "ArrowDown") {
                                                                        e.preventDefault();
                                                                        const next =
                                                                            index + 1 < firms.length ? index + 1 : 0;
                                                                        setFirmIndex(next);
                                                                        firmItemRefs.current[next]?.focus();
                                                                    }

                                                                    if (e.key === "ArrowUp") {
                                                                        e.preventDefault();
                                                                        const prev =
                                                                            index - 1 >= 0
                                                                                ? index - 1
                                                                                : firms.length - 1;
                                                                        setFirmIndex(prev);
                                                                        firmItemRefs.current[prev]?.focus();
                                                                    }

                                                                    if (e.key === "Enter") {
                                                                        e.preventDefault();
                                                                        setSelectedFirm(firm.GroupName);
                                                                        setSelectedFirmId(firm.DashboardFirmID);
                                                                        setSelectedDatabase(firm.databasename);
                                                                        setOpenFirm(false);
                                                                        setTimeout(() => {
                                                                            submitRef.current?.focus();
                                                                        }, 0);
                                                                    }

                                                                    if (e.key === "Escape") {
                                                                        setOpenFirm(false);
                                                                        firmRef.current?.focus();
                                                                    }
                                                                }}

                                                                onMouseEnter={(e) => {
                                                                    e.currentTarget.style.backgroundColor = "#e0ecff";
                                                                }}

                                                                onMouseLeave={(e) => {
                                                                    e.currentTarget.style.backgroundColor =
                                                                        selectedFirm === firm ? "#dbeafe" : "transparent";
                                                                }}

                                                                onFocus={(e) => {
                                                                    e.currentTarget.style.backgroundColor = "#dbeafe";
                                                                    e.currentTarget.style.outline = "none";
                                                                }}

                                                                onBlur={(e) => {
                                                                    e.currentTarget.style.backgroundColor =
                                                                        selectedFirm === firm ? "#dbeafe" : "transparent";
                                                                }}

                                                                style={{
                                                                    padding: "14px 16px",
                                                                    cursor: "pointer",
                                                                    backgroundColor:
                                                                        selectedFirm === firm ? "#dbeafe" : "transparent",
                                                                    color:
                                                                        selectedFirm === firm ? "#1d4ed8" : "#374151",
                                                                    fontWeight:
                                                                        selectedFirm === firm ? "600" : "500",
                                                                    transition: "all 0.2s ease",
                                                                    display: "flex",
                                                                    justifyContent: "space-between",
                                                                    alignItems: "center",
                                                                    borderLeft:
                                                                        selectedFirm === firm
                                                                            ? "4px solid #2563EB"
                                                                            : "4px solid transparent",
                                                                }}
                                                            >
                                                                {firm.GroupName}

                                                                {selectedFirm === firm && (
                                                                    <span style={{ color: "#2563EB" }}>✓</span>
                                                                )}
                                                            </div>
                                                        ))}
                                                    </div>
                                                )}
                                            </Form.Group>

                                            {(fpLoginData?.status === "OTP Match" ? fpLoginData?.Role : verifyData?.Role) === "millstageuser" && masters && masters.length > 0 && (
                                                <Form.Group className="mb-4 position-relative">
                                                    <div
                                                        ref={masterRef}
                                                        tabIndex={0}
                                                        style={getInputWrapperStyle("master")}
                                                        className="d-flex align-items-center justify-content-between px-3 cursor-pointer"
                                                        onClick={() => {
                                                            setOpenMaster(!openMaster);
                                                            setOpenYear(false);
                                                            setOpenFirm(false);
                                                        }}
                                                        onFocus={() => setActiveInput("master")}
                                                        onBlur={() => setActiveInput(null)}
                                                        onKeyDown={(e) => {
                                                            if (e.key === "Enter" || e.key === " ") {
                                                                e.preventDefault();
                                                                setOpenMaster(!openMaster);
                                                                setOpenYear(false);
                                                                setOpenFirm(false);
                                                            }
                                                            if (e.key === "ArrowDown" && openMaster) {
                                                                e.preventDefault();
                                                                masterItemRefs.current[0]?.focus();
                                                            }
                                                        }}
                                                    >
                                                        <span style={{ color: selectedMaster ? "#1e293b" : "#94a3b8", fontWeight: selectedMaster ? "600" : "500", fontSize: "15px" }}>
                                                            {selectedMaster || "Select Master"}
                                                        </span>
                                                        <IoIosArrowUp
                                                            style={{
                                                                color: "#64748b",
                                                                transition: "transform 0.3s ease",
                                                                transform: openMaster ? "rotate(180deg)" : "rotate(0deg)",
                                                            }}
                                                        />
                                                    </div>

                                                    {openMaster && (
                                                        <div
                                                            className="position-absolute w-100 mt-2 shadow-lg"
                                                            style={{
                                                                zIndex: 1000,
                                                                backgroundColor: "#ffffff",
                                                                borderRadius: "14px",
                                                                border: "1px solid #e2e8f0",
                                                                maxHeight: "220px",
                                                                overflowY: "auto",
                                                                boxShadow: "0 10px 25px -5px rgba(0, 0, 0, 0.1), 0 8px 10px -6px rgba(0, 0, 0, 0.1)",
                                                            }}
                                                        >
                                                            <div
                                                                style={{
                                                                    padding: "12px 16px",
                                                                    backgroundColor: "#cbd5e1",
                                                                    fontWeight: "600",
                                                                    fontSize: "14px",
                                                                }}
                                                            >
                                                                Select Master
                                                            </div>

                                                            {masters.map((mst, index) => (
                                                                <div
                                                                    key={mst.ProcessMstId}
                                                                    ref={(el) => (masterItemRefs.current[index] = el)}
                                                                    tabIndex={0}
                                                                    onClick={() => {
                                                                        setSelectedMaster(mst.ProcessMstName);
                                                                        setSelectedMasterId(mst.ProcessMstId);
                                                                        setOpenMaster(false);
                                                                    }}
                                                                    onKeyDown={(e) => {
                                                                        if (e.key === "ArrowDown") {
                                                                            e.preventDefault();
                                                                            const next = index + 1 < masters.length ? index + 1 : 0;
                                                                            setMasterIndex(next);
                                                                            masterItemRefs.current[next]?.focus();
                                                                        }
                                                                        if (e.key === "ArrowUp") {
                                                                            e.preventDefault();
                                                                            const prev = index - 1 >= 0 ? index - 1 : masters.length - 1;
                                                                            setMasterIndex(prev);
                                                                            masterItemRefs.current[prev]?.focus();
                                                                        }
                                                                        if (e.key === "Enter") {
                                                                            e.preventDefault();
                                                                            setSelectedMaster(mst.ProcessMstName);
                                                                            setSelectedMasterId(mst.ProcessMstId);
                                                                            setOpenMaster(false);
                                                                            setTimeout(() => {
                                                                                submitRef.current?.focus();
                                                                            }, 0);
                                                                        }
                                                                        if (e.key === "Escape") {
                                                                            setOpenMaster(false);
                                                                            masterRef.current?.focus();
                                                                        }
                                                                    }}
                                                                    onMouseEnter={(e) => { e.currentTarget.style.backgroundColor = "#e0ecff"; }}
                                                                    onMouseLeave={(e) => { e.currentTarget.style.backgroundColor = selectedMaster === mst.ProcessMstName ? "#dbeafe" : "transparent"; }}
                                                                    onFocus={(e) => { e.currentTarget.style.backgroundColor = "#dbeafe"; e.currentTarget.style.outline = "none"; }}
                                                                    onBlur={(e) => { e.currentTarget.style.backgroundColor = selectedMaster === mst.ProcessMstName ? "#dbeafe" : "transparent"; }}
                                                                    style={{
                                                                        padding: "14px 16px",
                                                                        cursor: "pointer",
                                                                        backgroundColor: selectedMaster === mst.ProcessMstName ? "#dbeafe" : "transparent",
                                                                        color: selectedMaster === mst.ProcessMstName ? "#1d4ed8" : "#374151",
                                                                        fontWeight: selectedMaster === mst.ProcessMstName ? "600" : "500",
                                                                        transition: "all 0.2s ease",
                                                                        display: "flex",
                                                                        justifyContent: "space-between",
                                                                        alignItems: "center",
                                                                        borderLeft: selectedMaster === mst.ProcessMstName ? "4px solid #2563EB" : "4px solid transparent",
                                                                    }}
                                                                >
                                                                    {mst.ProcessMstName}
                                                                    {selectedMaster === mst.ProcessMstName && (
                                                                        <span style={{ color: "#2563EB" }}>✓</span>
                                                                    )}
                                                                </div>
                                                            ))}
                                                        </div>
                                                    )}
                                                </Form.Group>
                                            )}
                                        </Form>
                                        <Button
                                            ref={submitRef}
                                            className="w-100 fw-semibold"
                                            onMouseEnter={() => setHoverSendOtp(true)}
                                            onMouseLeave={() => setHoverSendOtp(false)}
                                            onFocus={() => setActiveInput("submitBtn")}
                                            onBlur={() => setActiveInput(null)}
                                            onClick={Allset}

                                            style={{
                                                ...buttonStyle,
                                                transition: "all 0.25s ease",

                                                boxShadow:
                                                    activeInput === "submitBtn"
                                                        ? ""
                                                        : hoverSendOtp
                                                            ? "0 8px 20px rgba(37,99,235,0.4)"
                                                            : "none",

                                                transform: hoverSendOtp
                                                    ? "translateY(-2px)"
                                                    : "translateY(0px)",

                                                outline: "none",
                                            }}
                                        >
                                            Submit
                                            <FaArrowRight className="ms-2" />
                                        </Button>
                                    </div>
                                )}

                                {/* ================= REGISTER ================= */}
                                {page === "register" && (
                                    <>

                                        <div className="text-start p-0 m-0">
                                            <ArrowLeft
                                                size={17}
                                                style={{ cursor: "pointer", color: "#475569" }}
                                                onClick={() => setPage("login")}
                                                className="mt-2"
                                            />
                                        </div>
                                        {/* <div className="d-flex mb-4 "> */}

                                        <div className="ms-3 mb-4">
                                            <h4 className="fw-bold mb-0">Connect With Us</h4>
                                            <small style={{ color: "#405870" }}>
                                                Fill in Your details and we'll get back to you shortly
                                            </small>
                                        </div>
                                        {/* </div> */}


                                        <Form>
                                            {/* USERNAME */}
                                            <Form.Group className="mb-3 text-start">
                                                <Form.Label
                                                    className="fw-bold small"
                                                    style={{ color: "#405870" }}
                                                >
                                                    USER NAME
                                                </Form.Label>

                                                <div
                                                    className="d-flex align-items-center px-3"
                                                    style={getInputWrapperStyle("registerUsername")}
                                                    onClick={() => setActiveInput("registerUsername")}
                                                >
                                                    <Person
                                                        size={20}
                                                        color={
                                                            activeInput === "registerUsername"
                                                                ? "#2563EB"
                                                                : "#64748B"
                                                        }
                                                        className="me-2"
                                                    />
                                                    <Form.Control
                                                        type="text"

                                                        placeholder="Enter your user name"
                                                        style={inputStyle}
                                                        onFocus={() => setActiveInput("registerUsername")}
                                                    />
                                                </div>
                                            </Form.Group>

                                            {/* COMPANY NAME */}
                                            <Form.Group className="mb-3 text-start">
                                                <Form.Label
                                                    className="fw-bold small"
                                                    style={{ color: "#405870" }}
                                                >
                                                    COMPANY NAME
                                                </Form.Label>

                                                <div
                                                    className="d-flex align-items-center px-3"
                                                    style={getInputWrapperStyle("companyName")}
                                                    onClick={() => setActiveInput("companyName")}
                                                >
                                                    <Person
                                                        size={20}
                                                        color={
                                                            activeInput === "companyName"
                                                                ? "#2563EB"
                                                                : "#64748B"
                                                        }
                                                        className="me-2"
                                                    />
                                                    <Form.Control
                                                        type="text"
                                                        placeholder="Enter company name"
                                                        style={inputStyle}
                                                        onFocus={() => setActiveInput("companyName")}
                                                    />
                                                </div>
                                            </Form.Group>

                                            {/* EMAIL */}
                                            <Form.Group className="mb-3 text-start">
                                                <Form.Label
                                                    className="fw-bold small"
                                                    style={{ color: "#405870" }}
                                                >
                                                    EMAIL ADDRESS
                                                </Form.Label>

                                                <div
                                                    className="d-flex align-items-center px-3"
                                                    style={getInputWrapperStyle("email")}
                                                    onClick={() => setActiveInput("email")}
                                                >
                                                    <Envelope
                                                        size={20}
                                                        color={
                                                            activeInput === "email"
                                                                ? "#2563EB"
                                                                : "#64748B"
                                                        }
                                                        className="me-2"
                                                    />
                                                    <Form.Control
                                                        type="email"
                                                        placeholder="name@company.com"
                                                        style={inputStyle}
                                                        onFocus={() => setActiveInput("email")}
                                                    />
                                                </div>
                                            </Form.Group>

                                            {/* PHONE */}
                                            <Form.Group className="mb-4 text-start">
                                                <Form.Label
                                                    className="fw-bold small"
                                                    style={{ color: "#405870" }}
                                                >
                                                    PHONE
                                                </Form.Label>

                                                <div
                                                    className="d-flex align-items-center px-3"
                                                    style={getInputWrapperStyle("phone")}
                                                    onClick={() => setActiveInput("phone")}
                                                >
                                                    <Telephone
                                                        size={20}
                                                        color={
                                                            activeInput === "phone"
                                                                ? "#2563EB"
                                                                : "#64748B"
                                                        }
                                                        className="me-2"
                                                    />
                                                    <Form.Control
                                                        type="text"
                                                        placeholder="+1 (555) 000-0000"
                                                        style={inputStyle}
                                                        onFocus={() => setActiveInput("phone")}
                                                    />
                                                </div>
                                            </Form.Group>
                                            {/* REQUIREMENTS */}
                                            <Form.Group className="mb-3 text-start">
                                                <Form.Label
                                                    className="fw-bold small"
                                                    style={{ color: "#405870" }}
                                                >
                                                    REQUIREMENTS
                                                </Form.Label>

                                                <div
                                                    className="d-flex align-items-start px-3 py-2"
                                                    style={{
                                                        ...getInputWrapperStyle("description"),
                                                        height: "75px",
                                                    }}
                                                    onClick={() => setActiveInput("description")}
                                                >
                                                    <textarea
                                                        placeholder="Your requirements..."
                                                        style={{
                                                            width: "100%",
                                                            border: "none",
                                                            outline: "none",
                                                            background: "transparent",
                                                            resize: "none",
                                                            fontSize: "14px",
                                                        }}
                                                        rows="2"
                                                        onFocus={() => setActiveInput("description")}
                                                    />
                                                </div>
                                            </Form.Group>

                                            {/* BUTTON */}
                                            <Button
                                                className="w-100 fw-semibold"
                                                onMouseEnter={() => setHoverSendOtp(true)}
                                                onMouseLeave={() => setHoverSendOtp(false)}
                                                style={{
                                                    ...buttonStyle,
                                                    transition: "all 0.25s ease",
                                                    boxShadow: hoverSendOtp
                                                        ? "0 8px 20px rgba(37, 99, 235, 0.4)"
                                                        : "none",
                                                    transform: hoverSendOtp
                                                        ? "translateY(-2px)"
                                                        : "translateY(0px)",
                                                }}
                                            >
                                                Submit
                                                <LuSend className="ms-2" />
                                            </Button>
                                        </Form>
                                        <div className="text-center mt-4">
                                            <span style={{ color: "#475569", fontSize: "14px" }}>
                                                Already have an account?{" "}
                                            </span>
                                            <span
                                                style={{
                                                    color: "#2563EB",
                                                    fontWeight: "600",
                                                    cursor: "pointer",
                                                }}
                                                onClick={() => setPage("login")}
                                            >
                                                Log in
                                            </span>
                                        </div>
                                    </>
                                )}
                            </div>
                        </Col>
                    </Row>
                </Container>
                <ToastContainer
                    position="bottom-center"
                    autoClose={3000}
                    hideProgressBar={false}
                    newestOnTop={false}
                    closeOnClick
                    pauseOnHover
                />
            </div >
        </>
    );
};

export default Loginpage;